var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgForest = function SvgForest(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 4.5,
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4614_275825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7242 7.34513C14.456 7.13451 16.1039 5.79027 16.618 4C13.0127 5.71593 8.51537 3.61593 7.6667 7.40708L7.23307 9.42654C7.98882 8.20619 8.99236 7.55575 11.7242 7.34513ZM10.2994 7.68584C8.9552 7.88407 7.87732 8.52832 7.27643 9.66194C7.0844 10.0274 7.01626 10.4177 7.01626 10.4177L6.70652 11.8486C7.09059 11.1363 7.7844 10.2257 9.59944 9.79203C9.63661 9.56283 9.88439 8.26195 10.2994 7.68584ZM6.42157 13.1495L5.95077 15.3363C7.2021 12.877 9.89059 12.4 10.2251 12.3256C12.5667 11.8177 13.6941 10.6159 14.1464 9.05486C12.1021 10.2566 7.32599 8.75132 6.42157 13.1495ZM5.72776 16.3894L5.38086 18C8.14988 17.8389 8.45962 15.0885 8.90564 12.9018C8.04457 13.2115 6.1428 14.4318 5.72776 16.3894Z",
    fill: "#595959"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 4.5,
    stroke: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4614_275825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2371,
    height: 14,
    fill: "white",
    transform: "translate(5.38086 4)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgForest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "forest.2597a4b18899a74b15bfe97d5cbbaa0d.svg";